import React from 'react'
import { Box } from '@mui/material'
import Header from '../../components/Header'
import Bar from '../../components/Bar'

function BarChart() {
  return (
    <Box m="20px">
        <Header title="Bar Chart" subtitle="Simple Bar Chart"/>
        <Box height="75vh" >
            <Bar/>
        </Box>
    </Box>
  )
}

export default BarChart